import _ from "lodash";
import { Workbook } from "exceljs";
import * as fs from "file-saver";
import { Company } from "../../../gateway/Company/Company";
import { UserDataAdapter } from "../../adpters/UserDataAdapter";
export class CompanyContactsImportSpreadSheetGenerator {
    Company = new Company();
    user = new UserDataAdapter().user();
    workbook = new Workbook();
    worksheets = { cover: {}, companies: {} };
    textCover = {
        h1: `Essa planilha é um modelo para importar em lote todos os contatos de suas empresas para o controle das diversas funcionalidades na plataforma Nucont, entre elas: Acessos aos Dashes, pesquisa NPS, artigos do acesso a plataforma.`,
        h2: `Para iniciar, abra a aba 'Dados' e cadastre Nome, Whatsapp e e-mail de cada contato correspondente das empresas cadastradas na sua carteira
        `,
        h3: `É importante saber:`,
        p1: `O nome das empresas não permite alterações`,
        p2: `Preencha os Dados: Preencha os campos obrigatórios vazios: Nome, WhatsApp e E-mail do contato.`,
        p3: `Configurações Padrão: Os campos "NPS (pesquisa de satisfação)" e "Login Nucont" virão desativados por padrão. Você poderá alterá-los depois.`,
        p4: `Atenção à Atualização:A importação da planilha atualizará os contatos das empresas. Isso significa que você pode adicionar ou alterar contatos através deste arquivo e todos serão atualizados na área de Contatos da Nucont.`,
        p5: `Se alguns contatos forem removidos da planilha e importar na Nucont esses não serão excluídos da Nucont.`
    };
    contactsHeaderConfigs = [
        {
            merge: { start: "B1", end: "G1" },
            label: "Contato 1",
            columns: [
                { cell: "B", subheader: { label: "contactId" } },
                { cell: "C", subheader: { label: "Nome" } },
                { cell: "D", subheader: { label: "Whatsapp" } },
                { cell: "E", subheader: { label: "E-mail" } },
                { cell: "F", subheader: { label: "nps" } },
                { cell: "G", subheader: { label: "user" } }
            ]
        },
        {
            merge: { start: "H1", end: "M1" },
            label: "Contato 2",
            columns: [
                { cell: "H", subheader: { label: "contactId" } },
                { cell: "I", subheader: { label: "Nome" } },
                { cell: "J", subheader: { label: "Whatsapp" } },
                { cell: "K", subheader: { label: "E-mail" } },
                { cell: "L", subheader: { label: "nps" } },
                { cell: "M", subheader: { label: "user" } }
            ]
        },
        {
            merge: { start: "N1", end: "S1" },
            label: "Contato 3",
            columns: [
                { cell: "N", subheader: { label: "contactId" } },
                { cell: "O", subheader: { label: "Nome" } },
                { cell: "P", subheader: { label: "Whatsapp" } },
                { cell: "Q", subheader: { label: "E-mail" } },
                { cell: "R", subheader: { label: "nps" } },
                { cell: "S", subheader: { label: "user" } }
            ]
        },
        {
            merge: { start: "T1", end: "Y1" },
            label: "Contato 4",
            columns: [
                { cell: "T", subheader: { label: "contactId" } },
                { cell: "U", subheader: { label: "Nome" } },
                { cell: "V", subheader: { label: "Whatsapp" } },
                { cell: "W", subheader: { label: "E-mail" } },
                { cell: "X", subheader: { label: "nps" } },
                { cell: "Y", subheader: { label: "user" } }
            ]
        },
        {
            merge: { start: "Z1", end: "AE1" },
            label: "Contato 5",
            columns: [
                { cell: "Z", subheader: { label: "contactId" } },
                { cell: "AA", subheader: { label: "Nome" } },
                { cell: "AB", subheader: { label: "Whatsapp" } },
                { cell: "AC", subheader: { label: "E-mail" } },
                { cell: "AD", subheader: { label: "nps" } },
                { cell: "AE", subheader: { label: "user" } }
            ]
        },
        {
            merge: { start: "AF1", end: "AK1" },
            label: "Contato 6",
            columns: [
                { cell: "AF", subheader: { label: "contactId" } },
                { cell: "AG", subheader: { label: "Nome" } },
                { cell: "AH", subheader: { label: "Whatsapp" } },
                { cell: "AI", subheader: { label: "E-mail" } },
                { cell: "AJ", subheader: { label: "nps" } },
                { cell: "AK", subheader: { label: "user" } }
            ]
        },
        {
            merge: { start: "AL1", end: "AQ1" },
            label: "Contato 7",
            columns: [
                { cell: "AL", subheader: { label: "contactId" } },
                { cell: "AM", subheader: { label: "Nome" } },
                { cell: "AN", subheader: { label: "Whatsapp" } },
                { cell: "AO", subheader: { label: "E-mail" } },
                { cell: "AP", subheader: { label: "nps" } },
                { cell: "AQ", subheader: { label: "user" } }
            ]
        },
        {
            merge: { start: "AR1", end: "AW1" },
            label: "Contato 8",
            columns: [
                { cell: "AR", subheader: { label: "contactId" } },
                { cell: "AS", subheader: { label: "Nome" } },
                { cell: "AT", subheader: { label: "Whatsapp" } },
                { cell: "AU", subheader: { label: "E-mail" } },
                { cell: "AV", subheader: { label: "nps" } },
                { cell: "AW", subheader: { label: "user" } }
            ]
        },
        {
            merge: { start: "AX1", end: "BC1" },
            label: "Contato 9",
            columns: [
                { cell: "AX", subheader: { label: "contactId" } },
                { cell: "AY", subheader: { label: "Nome" } },
                { cell: "AZ", subheader: { label: "Whatsapp" } },
                { cell: "BA", subheader: { label: "E-mail" } },
                { cell: "BB", subheader: { label: "nps" } },
                { cell: "BC", subheader: { label: "user" } }
            ]
        },
        {
            merge: { start: "BD1", end: "BI1" },
            label: "Contato 10",
            columns: [
                { cell: "BD", subheader: { label: "contactId" } },
                { cell: "BE", subheader: { label: "Nome" } },
                { cell: "BF", subheader: { label: "Whatsapp" } },
                { cell: "BG", subheader: { label: "E-mail" } },
                { cell: "BH", subheader: { label: "nps" } },
                { cell: "BI", subheader: { label: "user" } }
            ]
        }
    ];
    headerConfigs = [
        {
            cell: "A1",
            label: "",
            columns: [
                {
                    cell: "A",
                    subheader: {
                        label: "Empresas",
                        bold: true,
                        horizontal: "left"
                    }
                }
            ]
        },
        ...this.contactsHeaderConfigs,
        {
            cell: "BJ1",
            label: "",
            columns: [{ cell: "BJ", subheader: { label: "_id" } }]
        }
    ];
    subheaderConfigs = [];
    cellBorder = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
    };
    cellFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "cfdbe6" }
    };
    editableColumns = [
        "C",
        "D",
        "E",
        "I",
        "J",
        "K",
        "O",
        "P",
        "Q",
        "U",
        "V",
        "W",
        "AA",
        "AB",
        "AC",
        "AG",
        "AH",
        "AI",
        "AM",
        "AN",
        "AO",
        "AS",
        "AT",
        "AU",
        "AY",
        "AZ",
        "BA",
        "BE",
        "BF",
        "BG"
    ];
    hideColumns = [
        "B",
        "F",
        "G",
        "H",
        "L",
        "M",
        "N",
        "R",
        "S",
        "T",
        "X",
        "Y",
        "Z",
        "AD",
        "AE",
        "AF",
        "AJ",
        "AK",
        "AL",
        "AP",
        "AQ",
        "AR",
        "AV",
        "AW",
        "AX",
        "BB",
        "BC",
        "BD",
        "BH",
        "BI",
        "BJ"
    ];
    constructor() {}

    async execute({ accountingId }) {
        if (!accountingId) return { response: false };
        const companies = await this.getCompaniesAndContacts({
            accountingId
        });
        this.setSubHeaderConfigs();
        this.setDocumentInfo();
        this.createCover();
        await this.createCompaniesPage({ companies });
        await this.saveAs();
        return { companies, response: true };
    }

    async getCompaniesAndContacts({ accountingId }) {
        const response = await this.Company.getGroupByContacts({
            accountingId,
            type: "company",
            userId: this.user._id,
            options: {}
        });
        return response?.list || [];
    }

    setSubHeaderConfigs() {
        for (const headerConfig of this.headerConfigs) {
            for (const column of headerConfig.columns) {
                const subheader = {
                    ...column.subheader,
                    cell: `${column.cell}2`
                };
                this.subheaderConfigs.push(subheader);
            }
        }
    }

    setDocumentInfo() {
        this.workbook.creator = "Nucont";
        this.workbook.created = new Date();
    }

    createCover() {
        this.worksheets.cover = this.workbook.addWorksheet("Resumo", {
            pageSetup: { paperSize: 9, orientation: "landscape" },
            views: [{ showGridLines: false }]
        });
        const cells = [
            { row: 5, start: "C5", end: "S5", text: this.textCover.h1 },
            { row: 7, start: "C7", end: "S7", text: this.textCover.h2 },
            {
                row: 9,
                start: "C9",
                end: "S9",
                text: this.textCover.h3,
                font: { bold: true }
            },
            { row: 10, start: "C10", end: "S10", text: this.textCover.p1 },
            { row: 11, start: "C11", end: "S11", text: this.textCover.p2 },
            { row: 12, start: "C12", end: "S12", text: this.textCover.p3 },
            { row: 14, start: "C14", end: "S14", text: this.textCover.p4 },
            { row: 16, start: "C16", end: "S16", text: this.textCover.p5 }
        ];
        for (const cell of cells) {
            this.worksheets.cover.mergeCells(`${cell.start}:${cell.end}`);
            const row = this.worksheets.cover.getRow(cell.row);
            row.height = 30;
            const worksheetCell = this.worksheets.cover.getCell(cell.start);
            worksheetCell.font = {
                name: "Arial",
                size: 12,
                ...(cell.font ? cell.font : {})
            };
            worksheetCell.alignment = {
                horizontal: "left",
                vertical: "middle",
                wrapText: true
            };
            worksheetCell.value = cell.text;
            worksheetCell.protection = {
                locked: true
            };
        }
    }

    async createCompaniesPage({ companies }) {
        this.worksheets.companies = this.workbook.addWorksheet("Dados", {
            views: [{ showGridLines: true }]
        });
        this.setHeader();
        this.setSubHeader();
        this.setCompaniesRows({ companies });
        this.unlockCells({ companies });
        this.setHideColumns();
        await this.worksheets.companies.protect("@nucontxxxx", {
            selectUnlockedCells: true,
            formatCells: true,
            formatColumns: true
        });
    }

    setHeader() {
        for (const header of this.headerConfigs) {
            const columns = header.columns;
            for (const column of columns) {
                this.worksheets.companies.getColumn(column.cell).width = 25;
            }
            if (header.merge) {
                this.worksheets.companies.mergeCells(
                    `${header.merge.start}:${header.merge.end}`
                );
                const cell = this.worksheets.companies.getCell(
                    header.merge.start
                );
                cell.fill = this.cellFill;
                cell.value = header.label;
                cell.font = { bold: true, size: 12, name: "Arial" };
                cell.alignment = { horizontal: "center" };
                cell.border = this.cellBorder;
                cell.protection = {
                    locked: true
                };
            } else {
                const cell = this.worksheets.companies.getCell(header.cell);
                cell.fill = this.cellFill;
                cell.value = header.label;
                cell.border = this.cellBorder;
                cell.protection = {
                    locked: true
                };
            }
        }
    }

    setSubHeader() {
        const columnA = this.worksheets.companies.getColumn("A");
        columnA.width = 50;
        for (const subheader of this.subheaderConfigs) {
            const cell = this.worksheets.companies.getCell(subheader.cell);
            cell.font = { bold: subheader.bold, size: 12, name: "Arial" };
            cell.alignment = { horizontal: subheader.horizontal || "center" };
            cell.value = subheader.label;
            cell.fill = this.cellFill;
            cell.border = this.cellBorder;
            cell.protection = {
                locked: true
            };
        }
    }

    setCompaniesRows({ companies }) {
        for (const [index, company] of companies.entries()) {
            const rowNumber = index + 3;
            const cell = this.worksheets.companies.getCell(`A${rowNumber}`);
            cell.value = company.props.name;
            cell.font = { size: 12, name: "Arial" };
            cell.alignment = { horizontal: "left" };
            cell.fill = this.cellFill;
            cell.border = this.cellBorder;
            cell.protection = {
                locked: true
            };
            const cellId = this.worksheets.companies.getCell(`BJ${rowNumber}`);
            cellId.value = company.props._id;
            this.setContacts({ company, rowNumber });
        }
    }

    setContacts({ company, rowNumber }) {
        const contactPropsMap = [
            "props._id",
            "props.name",
            "phone",
            "props.email",
            "props.relations.nps.status",
            "props.relations.user.status"
        ];
        for (
            let index = 0;
            index < this.contactsHeaderConfigs.length;
            index++
        ) {
            const headerConfig = this.contactsHeaderConfigs[index];
            for (
                let indexColumn = 0;
                indexColumn < headerConfig.columns.length;
                indexColumn++
            ) {
                const column = headerConfig.columns[indexColumn];
                const cellContactProp = this.worksheets.companies.getCell(
                    `${column.cell}${rowNumber}`
                );
                const contactProp = _.get(
                    company.props.contacts?.[index],
                    contactPropsMap[indexColumn]
                );
                cellContactProp.value = contactProp;
            }
        }
    }

    unlockCells({ companies }) {
        for (const [index, company] of companies.entries()) {
            const rowNumber = index + 3;
            for (const column of this.editableColumns) {
                const cell = this.worksheets.companies.getCell(
                    `${column}${rowNumber}`
                );
                cell.border = this.cellBorder;
                cell.font = { size: 12, name: "Arial" };
                cell.alignment = { horizontal: "left" };
                cell.protection = {
                    locked: false
                };
            }
        }
    }

    setHideColumns() {
        for (const column of this.hideColumns) {
            this.worksheets.companies.getColumn(column).hidden = true;
        }
    }

    async saveAs() {
        return new Promise((resolve) => {
            let fileName = `Nucont - Importacao de Contatos.xlsx`;
            this.workbook.xlsx.writeBuffer().then((data) => {
                let blob = new Blob([data], {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                fs.saveAs(blob, fileName);
                resolve(true);
            });
        });
    }
}
